import type { AttributeValidationHandler } from '../ui-element.type';
import { isBrandColor } from '../../global/helpers-marketing';

export const attributeColorValidator: AttributeValidationHandler = (
    component,
    value
) => {
    if (value === null) {
        return;
    }
    const info = `Allowed options are: turquoise, lilac, pineapple.`;
    if (['yellow', 'blue'].includes(value)) {
        console.warn(`${value} - color is deprecated. ${info}`, component);
        return;
    }
    if (!isBrandColor(value)) {
        console.warn(`${value} - value does not exist. ${info}`, component);
    }
};

export const attributeLayoutValidator: AttributeValidationHandler = (
    component,
    value
) => {
    if (value === null) {
        return;
    }
    const info = `Allowed options are: default, bubble.`;
    if (['centered'].includes(value)) {
        console.warn(`${value} - layout is deprecated. ${info}`, component);
        return;
    }
};
